<template>
  <main-template
    :header="header"
    :is-loading="isLoading"
  >
    <div class="container-fluid container">
      <section
        id="property-release"
        class="row"
        style="margin-bottom: 20px; padding: 20px 10px; background-color: #fafafa"
      >
        <div
          id="buy-release"
          class="col-xl-12"
          style="padding: 0"
        >
          <h2>Buy</h2>
          <small>New Release</small>
          <div
            id="buy_items"
            class="property-release__container list-horizontal"
          >
            <div>
              <ul>
                <li
                  v-for="(propertyBuy, index) of propertyBuyList"
                  :key="`buy-${index}`"
                >
                  <div
                    style="width: 100%; height: 200px; cursor: pointer; border-radius: 8px 8px 0 0"
                    @click="viewPropertyDetail(propertyBuy)"
                  >
                    <hg-carousel
                      type="image"
                      :image-list="getImageUrlList(propertyBuy.photoList)"
                    />
                  </div>
                  <div class="short_content">
                    <div
                      v-if="propertyBuy.status !== PROPERTY_STATUS.NO_STATUS"
                      class="building-type"
                      :class="`building-type-${propertyBuy.status}`"
                    >
                      {{PROPERTY_STATUS_TEXT[propertyBuy.status]}}
                    </div>
                    <div
                      v-if="propertyBuy.marketingWord !== ''"
                      class="marketing"
                    >
                      {{propertyBuy.marketingWord}}
                    </div>
                  </div>
                  <div style="padding: 10px">
                    <div
                      class="name"
                      style="cursor: pointer"
                      @click="viewPropertyDetail(propertyBuy)"
                    >
                      {{propertyBuy.name}}
                    </div>
                    <div class="location">
                      <img src="@/assets/icons/icon_location.svg" />{{getLocationTitle(propertyBuy.location)}}
                    </div>
                    <div
                      class="price"
                      style="margin: 10px 0"
                    >
                      <span class="currency">THB </span>
                      <span>{{numberFormat(propertyBuy.salePrice)}}</span>
                    </div>
                    <div class="overview">
                      <div class="property-type">
                        <img
                          :src='"@/assets/icons/"+getPropertyTypeIcon(propertyBuy.type)+""'
                          style="height: 18px; margin-right: 4px; opacity: .8"
                        />
                        <div>{{ PROPERTY_TYPE_TITLE[propertyBuy.type] || 'N/A' }}</div>
                      </div>
                      <div class="attr-icon-list">
                        <div
                          v-if="propertyBuy.sleep !== ''"
                          class="attr-icon"
                        >
                          <img
                            alt="attr-icon"
                            src="@/assets/icons/bedrooms.svg"
                          />
                          <div>{{propertyBuy.sleep}}</div>
                        </div>
                        <div
                          v-if="propertyBuy.bath !== ''"
                          class="attr-icon"
                        >
                          <img
                            alt="attr-icon"
                            src="@/assets/icons/bathrooms.svg"
                          />
                          <div>{{propertyBuy.bath}}</div>
                        </div>
<!--                        <div v-if="(propertyBuy.type === PROPERTY_TYPE.VILLAS_AND_HOUSES || propertyBuy.type === PROPERTY_TYPE.LAND) && propertyBuy.landArea !== ''"-->
<!--                             class="attr-icon">-->
<!--                          <img alt="attr-icon" src="@/assets/icons/area.svg">-->
<!--                          <div>{{propertyBuy.landArea}}</div>-->
<!--                        </div>-->
<!--                        <div class="attr-icon" v-if="propertyBuy.type === PROPERTY_TYPE.APARTMENTS_AND_CONDOS && propertyBuy.livingArea !== ''">-->
<!--                          <img alt="attr-icon" src="@/assets/icons/area.svg">-->
<!--                          <div>{{propertyBuy.livingArea}}</div>-->
<!--                        </div>-->
<!--                        <div class="attr-icon" v-if="propertyBuy.type === PROPERTY_TYPE.COMMERCIAL && propertyBuy.buildingArea !== ''">-->
<!--                          <img alt="attr-icon" src="@/assets/icons/area.svg">-->
<!--                          <div>{{propertyBuy.buildingArea}}</div>-->
<!--                        </div>-->
<!--                        <div class="attr-icon" v-if="propertyBuy.parking !== ''">-->
<!--                          <img alt="attr-icon" src="@/assets/icons/garage.svg">-->
<!--                          <div>{{propertyBuy.parking}}</div>-->
<!--                        </div>-->
                      </div>
                    </div>
                    <div style="text-align: right">
                      <a
                        class="btn__more-detail"
                        @click="viewPropertyDetail(propertyBuy)"
                      >
                        More detail
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <a
            class="btn btn--show-all"
            style="cursor: pointer"
            @click="gotoPage('buy')"
          >
            Show all property for sale
          </a>
        </div>
        <div
          id="rental-release"
          class="col-xl-12 mt-4"
          style="padding: 0"
        >
          <h2>Rent</h2>
          <small>Special Deals</small>
          <div
            id="rental_items"
            class="property-release__container list-horizontal"
          >
            <div>
              <ul>
                <li
                  v-for="(propertyRent, index) of propertyRentList"
                  :key="`rent-${index}`"
                >
                  <div
                    style="width: 100%; height: 189px; cursor: pointer; border-radius: 8px 8px 0 0"
                    @click="viewPropertyDetail(propertyRent)"
                  >
                    <hg-carousel
                      type="image"
                      :image-list="getImageUrlList(propertyRent.photoList)"
                    />
                  </div>
                  <div class="short_content">
                    <div
                      v-if="propertyRent.status !== PROPERTY_STATUS.NO_STATUS"
                      class="building-type"
                      :class="`building-type-${propertyRent.status}`"
                    >
                      {{PROPERTY_STATUS_TEXT[propertyRent.status]}}
                    </div>
                    <div
                      v-if="propertyRent.marketingWord !== ''"
                      class="marketing"
                    >
                      {{propertyRent.marketingWord}}
                    </div>
                  </div>
                  <div style="padding: 10px">
                    <div
                      class="name"
                      style="cursor: pointer"
                      @click="viewPropertyDetail(propertyRent)"
                    >
                      {{propertyRent.name}}
                    </div>
                    <div class="location">
                      <img src="@/assets/icons/icon_location.svg">{{getLocationTitle(propertyRent.location)}}
                    </div>
                    <div
                      class="price"
                      style="margin: 10px 0"
                    >
                      <span class="currency">THB </span>
                      <span>{{numberFormat(propertyRent.rentPrice)}}</span>
                      <span> /{{RENT_TYPE_TITLE[propertyRent.rentType] || ''}}</span>
                    </div>
                    <div class="overview">
                      <div class="property-type">
                        <img
                          :src='"@/assets/icons/"+getPropertyTypeIcon(propertyRent.type)+""'
                          style="height: 18px; margin-right: 4px; opacity: .8"
                        />
                        <div>{{ PROPERTY_TYPE_TITLE[propertyRent.type] || 'N/A' }}</div>
                      </div>
                      <div class="attr-icon-list">
                        <div
                          v-if="propertyRent.sleep !== ''"
                          class="attr-icon"
                        >
                          <img
                            alt="attr-icon"
                            src="@/assets/icons/bedrooms.svg"
                          />
                          <div>{{propertyRent.sleep}}</div>
                        </div>
                        <div
                          v-if="propertyRent.bath !== ''"
                          class="attr-icon"
                        >
                          <img
                            alt="attr-icon"
                            src="@/assets/icons/bathrooms.svg"
                          />
                          <div>{{propertyRent.bath}}</div>
                        </div>
<!--                        <div v-if="(propertyRent.type === PROPERTY_TYPE.VILLAS_AND_HOUSES || propertyRent.type === PROPERTY_TYPE.LAND) && propertyRent.landArea !== ''"-->
<!--                             class="attr-icon">-->
<!--                          <img alt="attr-icon" src="@/assets/icons/area.svg">-->
<!--                          <div>{{propertyRent.landArea}}</div>-->
<!--                        </div>-->
<!--                        <div class="attr-icon" v-if="propertyRent.type === PROPERTY_TYPE.APARTMENTS_AND_CONDOS && propertyRent.livingArea !== ''">-->
<!--                          <img alt="attr-icon" src="@/assets/icons/area.svg">-->
<!--                          <div>{{propertyRent.livingArea}}</div>-->
<!--                        </div>-->
<!--                        <div class="attr-icon" v-if="propertyRent.type === PROPERTY_TYPE.COMMERCIAL && propertyRent.buildingArea !== ''">-->
<!--                          <img alt="attr-icon" src="@/assets/icons/area.svg">-->
<!--                          <div>{{propertyRent.buildingArea}}</div>-->
<!--                        </div>-->
<!--                        <div class="attr-icon" v-if="propertyRent.parking !== ''">-->
<!--                          <img alt="attr-icon" src="@/assets/icons/garage.svg">-->
<!--                          <div>{{propertyRent.parking}}</div>-->
<!--                        </div>-->
                      </div>
                    </div>
                    <div style="text-align: right">
                      <a
                        class="btn__more-detail"
                        @click="viewPropertyDetail(propertyRent)"
                      >
                        More detail
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <a
            class="btn btn--show-all"
            style="cursor: pointer"
            @click="gotoPage('rental')"
          >
            Show all property for rent
          </a>
        </div>
      </section>

      <section id="why-property" class="row">
        <div class="row">
          <div
            v-html="homeDescription"
            class="col-lg-12 align-self-lg-center"
          >
          </div>
          <!--<div class="col-lg-6">-->
            <!--<h4>Why Phuket Villa and Home?</h4>-->
            <!--<p>Modern Property is a professional asset management company that will handle your property whether it is for rental or sale.</p>-->
          <!--</div>-->
        </div>
      </section>

      <section
        id="services"
        class="property-management"
      >
        <h2>Property Management Service</h2>
        <div class="row property-management__service">
          <div class="col-sm-4">
            <div class="property-management__service--item">
              <img
                src="@/assets/icons/icon_legal-consultant.svg"
                height="40"
                alt="Legal Consultant"
              />
              <div>
                <h3>Legal Consultant</h3>
                <div
                  v-html="legalConsultant"
                  class="property-service-content"></div>
                <router-link
                  class="btn-link"
                  target="_blank"
                  :to="{ name: 'LegalConsultant' }"
                >
                  More Detail
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="property-management__service--item">
              <img
                src="@/assets/icons/icon_villa-management.svg"
                height="40"
                alt="Villa Management"
              />
              <div>
                <h3>Villa Management</h3>
                <div
                  v-html="villaManagement"
                  class="property-service-content"></div>
                <router-link
                  class="btn-link"
                  target="_blank"
                  :to="{ name: 'VillaManagement' }"
                >
                  More Detail
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="property-management__service--item">
              <img
                src="@/assets/icons/icon_estate-management.svg"
                height="40"
                alt="Estate Management"
              />
              <div>
                <h3>Estate Management</h3>
                <div
                  v-html="estateManagement"
                  class="property-service-content"
                ></div>
                <router-link
                  class="btn-link"
                  target="_blank"
                  :to="{ name: 'EstateManagement' }"
                >
                  More Detail
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main-template>
</template>

<script>
import { get } from 'lodash'
import {
  LOCATION,
  LIST_TYPE,
  PROPERTY_TYPE,
  RENT_TYPE_TITLE,
  PROPERTY_STATUS,
  PROPERTY_STATUS_TEXT,
  PROPERTY_TYPE_TITLE,
  SERVICE_KEY,
  HERO_TEXT_CONFIG_KEY
} from '@/configs/constants'
import { numberFormat, getImageUrl, getImageUrlList, delay } from '@/helpers'
import HomeApi from '@/api/home-api'
import ConfigApi from '@/api/config-api'
import MainTemplate from '@/templates/MainTemplate'
import HgCarousel from '@/components/Carousel'

export default {
  name: 'Home',
  components: { MainTemplate, HgCarousel },
  data () {
    return {
      isLoading: false,
      getImageUrl,
      getImageUrlList,
      numberFormat,
      PROPERTY_TYPE,
      RENT_TYPE_TITLE,
      PROPERTY_STATUS,
      PROPERTY_STATUS_TEXT,
      PROPERTY_TYPE_TITLE,
      propertyBuyList: [],
      propertyRentList: [],
      legalConsultant: '',
      villaManagement: '',
      estateManagement: '',
      homeDescription: '',
      header: {
        className: '',
        style: '',
        imgPath: '',
        isShow: true,
        resizeLogo: true,
        heroText: {
          headline: '',
          subHeadline: ''
        }
      }
    }
  },
  computed: {
    prefetchItems () {
      return this.$store.state.prefetchItems
    }
  },
  async serverPrefetch () {
    await this.preparePrefetchItems(true)
  },
  async created () {
    try {
      this.isLoading = true
      await this.preparePrefetchItems(false)
      await delay(300)
      this.isLoading = false
    } catch (err) {
      // console.log(err)
    }
  },
  methods: {
    async preparePrefetchItems (isServerPrefetch) {
      let prefetchItems = this.prefetchItems
      if (prefetchItems === null) {
        const home = await HomeApi.list()
        const heroTextConfig = await ConfigApi.configByKey(HERO_TEXT_CONFIG_KEY.HOME)

        const header = {
          className: '',
          style: '',
          imgPath: home.coverImgUrl,
          isShow: true,
          resizeLogo: true,
          heroText: {}
        }
        const propertyBuyList = home.buy
        const propertyRentList = home.rental
        const serviceList = home.serviceList

        const legalConsultantResult = serviceList.find(item => item.key === SERVICE_KEY.LEGAL_CONSULTANT)
        const villaManagementResult = serviceList.find(item => item.key === SERVICE_KEY.VILLA_MANAGEMENT)
        const estateManagementResult = serviceList.find(item => item.key === SERVICE_KEY.ESTATE_MANAGEMENT)
        const homeResult = serviceList.find(item => item.key === SERVICE_KEY.HOME)

        const legalConsultant = (legalConsultantResult !== undefined) ? legalConsultantResult.value : ''
        const villaManagement = (villaManagementResult !== undefined) ? villaManagementResult.value : ''
        const estateManagement = (estateManagementResult !== undefined) ? estateManagementResult.value : ''
        const homeDescription = (homeResult !== undefined) ? homeResult.value : ''

        const heroTextValue = get(heroTextConfig, 'configValue', '{}')
        const heroText = JSON.parse(heroTextValue)
        header.heroText = heroText

        prefetchItems = {
          header,
          propertyBuyList,
          propertyRentList,
          legalConsultant,
          villaManagement,
          estateManagement,
          homeDescription
        }
      }

      if (isServerPrefetch) {
        this.$store.dispatch('initPrefetchItems', prefetchItems)
      } else {
        Object.assign(this, prefetchItems)

        this.$store.dispatch('clearPrefetchItems')
      }
    },
    getLocationTitle: function (locationId) {
      const result = LOCATION.find(item => item.id === locationId)

      if (result !== undefined) {
        return result.title
      }

      return 'N/A'
    },
    viewPropertyDetail: function (property) {
      return this.$router.push({
        name: 'PropertyDetail',
        params: {
          propertyId: property.id
        }
      })
    },
    gotoPage: function (page) {
      let routeName = 'Home'
      let routeParam

      switch (page) {
        case 'buy':
          routeName = 'AllPropertyListByType'
          routeParam = {
            listType: LIST_TYPE.BUY
          }

          break
        case 'rental':
          routeName = 'AllPropertyListByType'
          routeParam = {
            listType: LIST_TYPE.RENT
          }

          break
        case 'legalConsultant':
          routeName = 'LegalConsultant'

          break
        case 'villaManagement':
          routeName = 'VillaManagement'

          break
        case 'estateManagement':
          routeName = 'EstateManagement'

          break
      }

      return this.$router.push({
        name: routeName,
        params: routeParam
      })
    },
    getPropertyTypeIcon: function (type) {
      switch (type) {
        case PROPERTY_TYPE.VILLAS_AND_HOUSES:
          return 'icon_house.svg'
        case PROPERTY_TYPE.APARTMENTS_AND_CONDOS:
          return 'icon_condo.svg'
        case PROPERTY_TYPE.LAND:
          return 'icon_land.svg'
        case PROPERTY_TYPE.COMMERCIAL:
          return 'icon_house.svg'
        default:
          return 'icon_house.svg'
      }
    }
  }
}
</script>

<style scoped>
  .more-detail {
    position: relative;
    opacity: .35;
    text-decoration: underline;
    font-size:14px;
    cursor: pointer;
  }

  .btn-link {
    cursor: pointer;
  }

  .name:hover {
    text-decoration: underline;
  }

  .property-type {
    display: flex !important;
    align-self: center;
    color: #484848;
    font-weight: 500;
  }

  .attr-icon-list {
    display: flex;
    gap: 8px;
    height: 40px;
  }

  .attr-icon {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #484848;
    font-weight: 500;
  }

  .attr-icon img {
    height: 18px;
    margin-right: 5px;
    opacity: .8;
  }

  .property-service-content {
    height: 65px;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 20px
  }
</style>
